//@ts-check
import { repeat } from '@adobe/react-spectrum';
import { getResponsiveProp, useBreakpoint } from '@react-spectrum/utils';
import React from 'react';
import styled from 'styled-components';

/**
 * @param {number} count
 * @param {string[]} values
 */
const getColumns = (count, values) => repeat(Math.min(count, values.length), '1fr');

/**
 * @param {object} props
 * @param {string[]} props.values
 */
const BulletListGrid = ({ values }) => {
  const { matchedBreakpoints } = useBreakpoint();
  const columns = getResponsiveProp(
    {
      base: '1fr',
      S: getColumns(2, values),
      M: getColumns(3, values),
      L: getColumns(4, values),
    },
    matchedBreakpoints
  );

  return (
    <StyledList $columns={columns}>
      {values.map((value) => (
        <li key={value}>{value}</li>
      ))}
    </StyledList>
  );
};

/** @typedef {{ $columns: string }} StyledListProps */
const StyledList = styled.ul`
  margin: 0;
  display: grid;
  overflow-wrap: anywhere;
  padding-left: var(--spectrum-global-dimension-size-300);
  column-gap: var(--spectrum-global-dimension-size-300);
  row-gap: var(--spectrum-global-dimension-size-75);
  grid-template-columns: ${
    /** @param {StyledListProps} props */
    ({ $columns }) => $columns
  };
`;

export default BulletListGrid;
